import React, { Component } from "react";
import { connect } from "react-redux";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
// import { HashRouter as Router, Route, Switch } from "react-router-dom";
// import { createBrowserHistory } from 'history';
import {logoutUser, setUser} from "../../redux/actions/user";
import {API_TOKEN} from "../../redux/actions/user";
//component
import PageLoader from "./../../components/loader/PageLoader"
import PrivateRoute from "../misc/PrivateRoute";
import PublicRoute from "../misc/PublicRoute";
import Header from "../../components/header/Header";
import FooterPage from "../../components/footer/Footer";
import Login from "../auth/Login";
import Register from "../auth/Register";
//public page
import Home from "../home/Home";
import Products from "../products/Products";
import ProductDetail from "../products/ProductDetail";
import HowItWorks from "../faq/faq";
import Community from "../community/Community";
import ContactUs from "../contact/ContactUs";
import About from "../about/About";
import NotFound from "../misc/NotFound";
// User panel
import UsersPage from "../user/UsersPage";
import UsersProfile from "../user/UsersProfile";
import UserMerchantList from "./../merchants/UserMerchantList";
import UserMerchantAdd from "./../merchants/UserMerchantAdd";


//other public page
import RulesOfUse from "../pages/RulesOfUse";
import HotelRules from "../pages/HotelRules";
import Business from "../pages/Business";
import MerchantPartners from "../pages/MerchantPartners";
import Careers from "../pages/Careers";
import Licences from "../pages/Licences";
import TermsOfSale from "../pages/TermsOfSale";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfUse from "../pages/TermsOfUse";
import SiteMap from "../pages/Sitemap";
import MerchantList from "../merchants/MerchantList";
import MerchantListByCat from "../merchants/MerchantListByCat";
import MerchantItem from "../merchants/MerchantItem";
import HelpItem from "../faq/HelpItem";

import {CheckUserLoginFromApi} from "../../redux/utils/authUtils";
import {setCategories} from "../../redux/actions/categories";
import axios from "axios/index";
import {API_URL} from "../../config/Config";
import UserMerchantEdit from "../merchants/UserMerchantEdit";

// const history = createBrowserHistory();

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
          apiToken:"",
          is_authenticated:false,
          isLoading: true,
        }
    }

    async componentDidMount() {
        const {store} = this.props;
        await CheckUserLoginFromApi(store);
        let apiToken = await localStorage.getItem(API_TOKEN);
       let is_authenticated = false;
        // console.log(apiToken);
        if (apiToken === null || apiToken ===""){
            console.log("token is invalid");
            is_authenticated = false;
            this.props.logoutUser();
        }else {
           if ((this.props.user.firstName === undefined  )  || (this.props.user.firstName === null)){
                console.log("user not valid");
                is_authenticated = false;
                this.props.logoutUser();
            }else{
                console.log("token available");
                is_authenticated = true;
            }
        }
        //----------------------
        if (!this.props.categories.isFetching){
            await this.getCategoriesApi();
        }
        //----------------------
        this.setState({isLoading: false,is_authenticated})
    }
    async getCategoriesApi() {
        let response = await axios.get(`${API_URL}category`);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);
            alert('خطایی در هنگام دریافت اطلاعات از سرور رخ داد.');
        }else{
            let categories = response.data.data;
            this.props.setCategories(categories);
        }
        // console.log("done");
    };
    render() {
        const {is_authenticated} = this.state;

        return (
            this.state.isLoading ?
                <PageLoader type="bubbles" color="#4fbfa8" />
                :
                <Router forceRefresh={true} >
                    <div>
                      <div className="">
                        <Header isAuthenticated={is_authenticated} />
                        <div className='appContent'>
                            <Switch>
                              {/*<Route exact={true} path="/" component={Home}/>*/}
                                <Route exact={true} path="/" render={(props) => <Home catMenu={this.state.catMenu} {...props}/>}/>
                                <Route path="/products" component={Products} />
                                <Route path="/how-it-works" component={HowItWorks} />
                                <Route path="/community" component={Community} />
                                <Route path="/contact-us" component={ContactUs} />

                                <Route path="/product/:id" component={ProductDetail} />

                                <Route path="/merchantList" component={MerchantList} />
                                <Route path="/merchants/:id" component={MerchantListByCat} />
                                <Route path="/merchant/:id" component={MerchantItem} />

                                <Route path="/faq/:id" component={HelpItem} />
                                {/*//public Routes*/}
                                <PublicRoute path="/register" isAuthenticated={is_authenticated} component={Register}/>
                                <PublicRoute path="/login" isAuthenticated={is_authenticated} component={Login}/>
                                {/*//Private Routes*/}
                                <PrivateRoute path="/users" isAuthenticated={is_authenticated} component={UsersPage}/>
                                <PrivateRoute path="/profile" isAuthenticated={is_authenticated} component={UsersProfile}/>
                                <PrivateRoute path="/my-jobs" isAuthenticated={is_authenticated} component={UserMerchantList}/>
                                <PrivateRoute path="/new-job" isAuthenticated={is_authenticated} component={UserMerchantAdd}/>
                                <PrivateRoute path="/edit-job/:id" isAuthenticated={is_authenticated} component={UserMerchantEdit}/>
                                <PrivateRoute path="/setting" isAuthenticated={is_authenticated} component={UsersPage}/>
                                <PrivateRoute path="/refer-to-friend" isAuthenticated={is_authenticated} component={UsersPage}/>

                                {/*Contents*/}
                                <Route path="/rules-of-use" component={RulesOfUse} />
                                <Route path="/hotel-rules" component={HotelRules} />
                                <Route path="/business" component={Business} />
                                <Route path="/merchant-partners" component={MerchantPartners} />
                                <Route path="/careers" component={Careers} />
                                <Route path="/licences" component={Licences} />
                                <Route path="/terms-of-sale" component={TermsOfSale} />
                                <Route path="/terms-of-use" component={TermsOfUse} />
                                <Route path="/privacy-policy" component={PrivacyPolicy} />
                                <Route path="/about" component={About} />
                                <Route path="/sitemap" component={SiteMap} />

                                <Route component={NotFound} />
                            </Switch>
                        </div>
                      </div>
                      <FooterPage  />
                    </div>
                </Router>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user : state.user,
        categories: state.categories,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser : user => {
            dispatch(setUser(user))
        },
        logoutUser : () =>{
            dispatch(logoutUser())
        },
        setCategories : categories => {
            dispatch(setCategories(categories))
        }
    }
};
export default connect(mapStateToProps,mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/app/App.js